import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ChecklistIcon from '@mui/icons-material/Checklist';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import React, {useEffect, useState} from "react";
import {usePWAInstall} from 'react-use-pwa-install'
import useSalepoints from "./useSalepoints.ts";
// import {useAppContext} from "./Context.tsx";

export default function DrawerList() {
    // const {preferredShop, setPreferredShop} = useAppContext()
    const {favoriteShop,setFavoriteShop} = useSalepoints()
    const pwaInstall = usePWAInstall()
    return (
        <Box sx={{width: '100%', maxWidth: 960, bgcolor: 'background.paper'}}>
            <nav aria-label="secondary mailbox folders">
                <List>
                    <ListItem disablePadding>
                        <ListItemButton href="/">
                            <ListItemIcon>
                                <CameraAltIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Новый документ"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton component="a" href="/docs">
                            <ListItemIcon>
                                <ChecklistIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Документы"/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton component="a">
                            <ListItemIcon>
                                <SettingsSuggestIcon/>
                            </ListItemIcon>
                            <ListItemText primary={favoriteShop?.name ?? "не указан"} onClick={() => {
                                setFavoriteShop(undefined)
                            }}/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton component="button" >
                            <ListItemIcon>
                                <SettingsSuggestIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Установить" onClick={pwaInstall}/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton component="a" href="#simple-list">
                            <ListItemIcon>
                                <ExitToAppIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Выход"/>
                        </ListItemButton>
                    </ListItem>
                </List>
            </nav>
        </Box>
    );
}